<app-modal [name]="name" [title]="'SIDEBAR.PASSWORD' | translate" size="lg">
  <button class="btn btn-tertiary pl-4 pr-4 mt-4 mb-5" (click)="onMyaccount()">
    {{ "BUTTON.MYACCOUNT" | translate }}
  </button>
  <!--
  <iframe *appIsFeatureFlagEnabled="'enableAccountInfoFrame'" class="account" title="Account settings" [src]="iframeSrc | sanitizeUrl:'trustResourceUrl'"></iframe>
  -->
</app-modal>
